import { UPDATE_LOYALTY, UPDATE_LOYALTY_REWARDS, GET_LOYALTY_REWARDS_PER_LEVEL } from "../actions/types";

const initialState = {
	loyaltySettings: {},
	rewards: [],
	rewardsPerLevel: {
		silver: [],
		gold: [],
		platinum: [],
	},
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_LOYALTY:
			return { ...state, loyaltySettings: { ...state.loyaltySettings, ...action.payload } };
		case UPDATE_LOYALTY_REWARDS:
			return { ...state, rewards: action.payload };
		case GET_LOYALTY_REWARDS_PER_LEVEL:
			return {
				...state,
				rewardsPerLevel: {
					...state.rewardsPerLevel,
					...action.payload,
				},
			};
		default:
			return state;
	}
};

export default reducer;
